module.exports = __webpack_public_path__ + "img/glovo2.44763000.jpeg";